import React from 'react'

export const PageNotFound = () => {
   return (
    <div style={{ textAlign: 'center', padding: '100px 20px' }}>
      <h1>404 - Page Not Found</h1>
      <p>Oops! The page you're looking for does not exist.</p>
    </div>
  );
}
